import { useEffect } from "react";
import { View, Text, Button, useTheme } from "reshaped";
import { IconMoon, IconSun } from "../../icons";

export const Header = (props: {
  changeThema: VoidFunction;
  isDark: boolean;
}) => {
  const { changeThema, isDark } = props;
  const { setColorMode } = useTheme();
  
  useEffect(() => {
    if (isDark) {
      setColorMode("dark");
      localStorage.setItem("theme", "dark");
    } else {
      setColorMode("light");
      localStorage.setItem("theme", "light");
    }
  }, [isDark, setColorMode]);
  
  return (
    <View padding={8} direction="row">
      <Text variant="featured-1" weight="bold">
        Desarrollador de Software
      </Text>

      <View.Item gapBefore="auto">
        <Button onClick={changeThema}>
          {isDark ? <IconSun /> : <IconMoon />}
        </Button>
      </View.Item>
    </View>
  );
};
